import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * Example:
 *   about: { it: 'chi-siamo', en: 'about-us' }
 *   → /it/chi-siamo, /en/about-us
 */
export const localizedRoutes = {
  home: { it: '', en: '' },
  contacts: { it: 'contatti', en: 'contacts' },
  privacy: { it: 'privacy', en: 'privacy' },
  about: { it: 'chi-siamo', en: 'about-us' },
  divisions: { it: 'prodotti', en: 'products' },
  divisionScatole: { it: 'prodotti/scatole', en: 'products/boxes' },
  divisionImballaggi: { it: 'prodotti/imballaggi', en: 'products/packaging' },
  divisionCartotecnica: { it: 'prodotti/cartotecnica', en: 'products/paperboard' },
  divisionTrasporti: { it: 'prodotti/trasporti-logistica', en: 'products/transport-logistics' },
  divisionMacchinari: { it: 'prodotti/macchinari', en: 'products/machinery' },
  divisionLegno: { it: 'prodotti/legno', en: 'products/wood' },
  divisionIgiene: { it: 'prodotti/igiene-monouso', en: 'products/hygiene' },
  divisionForniture: { it: 'prodotti/forniture-ufficio', en: 'products/office-supplies' },
  certifications: { it: 'certificazioni', en: 'certifications' },

  careers: { it: 'lavora-con-noi', en: 'careers' },
  environmental: { it: 'etichettatura-ambientale', en: 'environmental-labeling' },
  cookiePolicy: { it: 'cookie-policy', en: 'cookie-policy' },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
